// Bildet den Bestellschlüssel für eine Einzelkulisse (Issue #22).
//
// Format: {Kulissentyp}{Kulissenbreite}-{Kulissenhoehe}-{Kulissenlaenge}-Kulisse
// Beispiel: HKS100-1000-1000-Kulisse
//
// Reine Zeichenketten-Bildung für Anzeige (PDF-Überschrift) und Dateiname –
// keine Berechnung.
export function getKulissenBestellschluessel({
  Kulissentyp,
  Kulissenbreite,
  Kulissenhoehe,
  Kulissenlaenge,
}) {
  return `${Kulissentyp}${Kulissenbreite}-${Kulissenhoehe}-${Kulissenlaenge}-Kulisse`;
}
